import { useTranslation } from 'next-i18next';
import { NextSeo, NextSeoProps } from 'next-seo';

const Seo = ({ title, ...props }: NextSeoProps) => {
  const { t } = useTranslation();

  return <NextSeo {...props} title={`${title} - ${t('채티')}`} />;
};

export default Seo;
